export class Multiplex {
   id: number;
   name: string;
   email: string;
   hide_name: any;
}
